import { type MatrixEvent } from "matrix-js-sdk/src/matrix";

import { MatrixClientPeg } from "../../../MatrixClientPeg";
import { DefaultTagID, type TagID } from "../../room-list-v3/skip-list/tag";
import { isDmRoom } from "../../../dth/utils";
import { getSenderNameFromMatrixEvent } from "../../../utils/event/eventUtils";

/**
 * Checks if the given event was sent by the current user.
 * @param event The event to check.
 * @returns True if the event was sent by the current user, false otherwise.
 */
export function isSelf(event: MatrixEvent): boolean {
    const selfUserId = MatrixClientPeg.safeGet().getSafeUserId();
    const eventType = event.getType();
    if (eventType === "m.room.member") {
        return event.getStateKey() === selfUserId;
    }
    const senderId = event.getSender();
    return senderId === selfUserId;
}

/**
 * Checks if messages in the given room should be prefixed with the sender's name.
 * @param roomId The ID of the room to check.
 * @param tagId The tag ID of the room, if any.
 * @returns True if messages in the room should be prefixed, false otherwise.
 */
export function shouldPrefixMessagesIn(roomId: string, tagId?: TagID): boolean {
    // la chat è taggata ma non come DM, bisogna mostrare il prefisso del mittente    
    if (tagId != null && tagId !== DefaultTagID.DM) return true;

    // We don't prefix anything in 1:1s
    const room = MatrixClientPeg.safeGet().getRoom(roomId);
    if (!room) return true;

    // Viene controllato il numero di membri per ottimizzare il caso dei gruppi con più utenti, 
    // evitando di fare la chiamata a isDmRoom che è più costosa.
    const memberCount = room.currentState.getJoinedMemberCount();
    // se non sono due membri, sicuramente non è una chat 1:1, bisogna mostrare il prefisso del mittente
    if (memberCount !== 2) return true;

    // se sono esattamente due membri, potrebbe essere una chat 1:1, 
    // ma bisogna controllare se è effettivamente una DM o se è una chat di gruppo senza tag DM
    const isDm = isDmRoom(room);
    // la chat non è una DM, bisogna mostrare il prefisso del mittente    
    return !isDm;
}

export function getSenderName(event: MatrixEvent): string {
    return getSenderNameFromMatrixEvent(event);
}
